import { UiKitSize } from '../../types/uikit.types';

export const CONTENT_GAP_MAP: Record<UiKitSize, number> = {
  md: 4,
  sm: 1,
};
